export { default } from './mailer';
